/* EcoCarry: max 2 per sample-kit product, across variants and cart lines. */
(function () {
  'use strict';
  const config = window.ecSampleKitConfig;
  if (!config || window.ecSampleKitLimit) return;
  const variants = Object.assign(Object.create(null), config.variants);
  const products = new Set(Object.values(variants).map(String));
  const text = window.ecSampleKitText || {};
  const message = text.limit || 'You can purchase up to 2 pieces of each sample kit per order.';
  const nativeFetch = window.fetch.bind(window);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let cart = config.cart || { items: [] };
  let queue = Promise.resolve();
  let activeInput = null;
  const warnings = new Map();
  function serial(task) {
    const result = queue.then(task, task);
    queue = result.catch(function () {});
    return result;
  }
  function endpoint(url) {
    const parsed = new URL(url, location.href);
    return parsed.origin === location.origin && /\/cart\/(add|change|update)(?:\.js)?$/.exec(parsed.pathname);
  }
  function decode(body) {
    if (!body) return {};
    if (typeof body === 'string' && /^\s*\{/.test(body)) return JSON.parse(body);
    if (body instanceof FormData || body instanceof URLSearchParams || typeof body === 'string') {
      const params = typeof body === 'string' ? new URLSearchParams(body) : body;
      const result = Object.create(null);
      for (const [key, value] of params.entries()) {
        if (key === 'updates[]') (result.updates || (result.updates = [])).push(value);
        else {
          const update = /^updates\[([^\]]+)\]$/.exec(key);
          const item = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(key);
          if (update) (result.updates || (result.updates = Object.create(null)))[update[1]] = value;
          else if (item) {
            result.items = result.items || [];
            result.items[item[1]] = result.items[item[1]] || {};
            result.items[item[1]][item[2]] = value;
          } else result[key] = value;
        }
      }
      return result;
    }
    return body;
  }
  function project(current, action, payload) {
    const lines = current.items.map(function (item) { return Object.assign({}, item); });
    if (action === 'add') {
      (payload.items || [payload]).forEach(function (item) {
        if (!item) return;
        const product = variants[String(item.id)];
        if (product) lines.push({ product_id: product, quantity: Number(item.quantity == null ? 1 : item.quantity) });
      });
    } else if (action === 'change') {
      const target = payload.line ? lines[Number(payload.line) - 1] :
        lines.find(function (item) { return item.key === String(payload.id) || String(item.variant_id || item.id) === String(payload.id); });
      if (target && payload.quantity != null) target.quantity = Number(payload.quantity);
    } else if (action === 'update' && payload.updates) {
      const updates = payload.updates;
      if (Array.isArray(updates)) updates.forEach(function (qty, i) { if (lines[i]) lines[i].quantity = Number(qty); });
      else Object.keys(updates).forEach(function (id) {
        const keyed = lines.find(function (item) { return item.key === id; });
        const matches = keyed ? [keyed] : lines.filter(function (item) { return String(item.variant_id || item.id) === id; });
        if (matches.length) matches.forEach(function (item) { item.quantity = Number(updates[id]); });
        else if (variants[id]) lines.push({ product_id: variants[id], quantity: Number(updates[id]) });
      });
    }
    return lines;
  }
  function totals(lines) {
    const result = {};
    lines.forEach(function (item) {
      const product = String(item.product_id);
      if (products.has(product)) result[product] = (result[product] || 0) + Number(item.quantity);
    });
    return result;
  }
  function allowed(current, action, payload) {
    const projected = project(current, action, payload);
    if (projected.some(function (item) {
      return products.has(String(item.product_id)) && (!Number.isSafeInteger(Number(item.quantity)) || Number(item.quantity) < 0);
    })) return false;
    const before = totals(current.items);
    const after = totals(projected);
    // Allow reductions of a pre-existing invalid cart, one line at a time.
    return Object.keys(after).every(function (id) { return after[id] <= 2 || after[id] <= (before[id] || 0); });
  }
  function notify(value, input) {
    input = input || activeInput;
    const info = input && identifyInput(input);
    if (info) warnings.set(info.product, value || message);
    const holder = input && (input.closest('.cart-actions') || input.closest('.js-qty') || input.parentElement);
    const fallback = document.querySelector('form.cart') || document.querySelector('main') || document.body;
    const parent = holder ? holder.parentElement : fallback;
    let box = Array.from(parent.children).find(function (node) { return node.classList.contains('ec-kit-limit-error'); });
    if (!box) {
      box = document.createElement('p');
      box.className = 'ec-kit-limit-error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'display:block;clear:both;flex-basis:100%;font-size:13px;line-height:1.5;margin:10px 0 0;color:#9b3328';
      if (holder) holder.insertAdjacentElement('afterend', box);
      else parent.appendChild(box);
    }
    box.textContent = value || message;
    box.hidden = false;
    box.style.display = 'block';
  }
  function clearNotice(input) {
    const info = input && identifyInput(input);
    if (info) warnings.delete(info.product);
    const holder = input && (input.closest('.cart-actions') || input.closest('.js-qty') || input.parentElement);
    if (!holder) return;
    Array.from(holder.parentElement.children).forEach(function (node) {
      if (node.classList.contains('ec-kit-limit-error')) { node.hidden = true; node.style.display = 'none'; }
    });
  }
  async function readCart() {
    const response = await nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(text.cartError || 'Unable to check your cart. Please try again.');
    cart = await response.json();
    refreshUI();
    return cart;
  }
  function rejectResponse(text) {
    notify(text);
    refreshUI();
    document.querySelectorAll('.is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
    return new Response(JSON.stringify({ status: 422, message: text, description: text }), { status: 422, headers: { 'Content-Type': 'application/json' } });
  }
  async function guarded(url, body, send) {
    const match = endpoint(url);
    return serial(async function () {
      let current;
      try { current = await readCart(); }
      catch (e) { return rejectResponse(e.message); }
      let payload;
      try { payload = decode(body); } catch (e) { return rejectResponse(text.cartError); }
      if (!allowed(current, match[1], payload)) return rejectResponse(message);
      const response = await send();
      // Keep the queue locked until the server's cart reflects this mutation.
      try { await readCart(); } catch (e) { /* The next mutation always checks again. */ }
      return response;
    });
  }
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    const method = (init && init.method) || (input instanceof Request ? input.method : 'GET');
    if (!endpoint(url) || /^(GET|HEAD)$/i.test(method)) return nativeFetch(input, init);
    let body = init && init.body;
    if (body == null && input instanceof Request) {
      const copy = input.clone();
      body = /multipart\/form-data/.test(copy.headers.get('content-type') || '') ? await copy.formData() : await copy.text();
    }
    return guarded(url, body, function () { return nativeFetch(input, init); });
  };
  function installJQuery() {
    const $ = window.jQuery;
    if (!$ || $.ecKitLimitInstalled) return;
    $.ecKitLimitInstalled = true;
    // Preserve jQuery callbacks, Deferreds and JSON error handling using its transport API.
    $.ajaxTransport('+*', function (options) {
      if (!endpoint(options.url) || /^(GET|HEAD)$/i.test(options.type) || options.async === false) return;
      let controller;
      return {
        send: function (headers, complete) {
          controller = new AbortController();
          if (options.contentType && !(options.data instanceof FormData)) headers['Content-Type'] = options.contentType;
          guarded(options.url, options.data, function () {
            return nativeFetch(options.url, { method: options.type, body: options.data, headers: headers, credentials: 'same-origin', signal: controller.signal });
          }).then(async function (response) {
            let headerText = '';
            response.headers.forEach(function (value, key) { headerText += key + ': ' + value + '\r\n'; });
            complete(response.status, response.statusText, { text: await response.text() }, headerText);
          }).catch(function (error) { complete(0, error.name === 'AbortError' ? 'abort' : 'error'); });
        },
        abort: function () { if (controller) controller.abort(); }
      };
    });
  }
  function identifyInput(input) {
    if (input.dataset.line) {
      const line = cart.items[Number(input.dataset.line) - 1];
      if (line && products.has(String(line.product_id))) return { product: String(line.product_id), line: line };
    }
    const form = input.closest('form');
    const id = form && form.querySelector('[name="id"]');
    if (id && variants[String(id.value)]) return { product: String(variants[String(id.value)]) };
    if (input.id === 'quantity-input' && products.has(String(config.current))) return { product: String(config.current) };
    return null;
  }
  function refreshUI() {
    if (!document.body) return;
    document.querySelectorAll('input[name="quantity"],input[name="updates[]"],input.js-qty__input,input.qv-quantity').forEach(function (input) {
      const info = identifyInput(input);
      if (!info) return;
      const total = totals(cart.items)[info.product] || 0;
      const max = Math.max(0, 2 - total + (info.line ? Number(info.line.quantity) : 0));
      input.max = String(max);
      input.dataset.ecKitMax = String(max);
      if (info.line && total > 2) notify(message, input);
      else if (warnings.has(info.product)) notify(warnings.get(info.product), input);
    });
  }
  function handleQuantityEdit(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const desired = Number(input.value);
    refreshUI();
    if (input.dataset.ecKitMax && desired > Number(input.dataset.ecKitMax)) {
      activeInput = input;
      input.value = String(Math.max(identifyInput(input).line ? 0 : 1, Number(input.dataset.ecKitMax)));
      notify(message, input);
    } else if (event.type === 'input' && identifyInput(input)) clearNotice(input);
  }
  document.addEventListener('input', handleQuantityEdit, true);
  document.addEventListener('change', handleQuantityEdit, true);
  let approvedClick = null;
  document.addEventListener('click', function (event) {
    const button = event.target instanceof Element && event.target.closest('button,a,input[type="submit"]');
    if (!button) return;
    if (approvedClick === button) { approvedClick = null; return; }
    const buttonForm = button.closest('form');
    const quantityInput = buttonForm && buttonForm.querySelector('input[name="quantity"]');
    if (quantityInput && identifyInput(quantityInput) && button.matches('.add-to-cart-btn,[name="add"],button[type="submit"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      activeInput = quantityInput;
      serial(async function () {
        try {
          await readCart();
          if (Number(quantityInput.value) > Number(quantityInput.dataset.ecKitMax)) { notify(message, quantityInput); return; }
          clearNotice(quantityInput);
          approvedClick = button; button.click(); approvedClick = null;
        } catch (e) { notify(text.cartError, quantityInput); }
      });
      return;
    }
    if (button.matches('.js-qty__plus,.js-qty__adjust--plus,#as-increase')) {
      const input = button.parentElement.querySelector('input');
      refreshUI();
      if (input && input.dataset.ecKitMax && Number(input.value) >= Number(input.dataset.ecKitMax)) {
        activeInput = input;
        event.preventDefault(); event.stopImmediatePropagation(); notify(message, input); return;
      }
    }
    if (button.matches('#as-decrease,.js-qty__minus,.js-qty__adjust--minus')) {
      const input = button.parentElement.querySelector('input');
      if (input) clearNotice(input);
    }
    if (button.matches('.gokwik-checkout button,.js-cart-btn-checkout,[name="checkout"],a[href*="/checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      serial(async function () {
        try {
          const current = await readCart();
          if (Object.values(totals(current.items)).some(function (qty) { return qty > 2; })) { notify(text.checkoutError); return; }
          approvedClick = button; button.click(); approvedClick = null;
        } catch (e) { notify(e.message); }
      });
    }
  }, true);
  const approvedForms = new WeakSet();
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (approvedForms.has(form)) { approvedForms.delete(form); return; }
    const action = new URL(form.action, location.href);
    const match = endpoint(action.href);
    const isCart = /\/cart\/?$/.test(action.pathname);
    if (!match && !isCart) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const submitter = event.submitter;
    serial(async function () {
      try {
        const current = await readCart();
        const payload = decode(new FormData(form));
        const kind = match ? match[1] : 'update';
        if (!allowed(current, kind, payload)) { notify(); return; }
        const checkout = submitter && submitter.name === 'checkout';
        if (checkout && Object.values(totals(project(current, kind, payload))).some(function (qty) { return qty > 2; })) { notify(); return; }
        approvedForms.add(form);
        form.requestSubmit(submitter || undefined);
      } catch (e) { notify(e.message); }
    });
  }, true);
  window.ecSampleKitLimit = { allowed: allowed, project: project, totals: totals };
  function ready() {
    installJQuery();
    refreshUI();
    let pending = false;
    new MutationObserver(function (changes) {
      if (pending || !changes.some(function (change) { return Array.from(change.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches('input,form') || node.querySelector('input,form')); }); })) return;
      pending = true; requestAnimationFrame(function () { pending = false; refreshUI(); });
    }).observe(document.body, { childList: true, subtree: true });
    readCart().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();